import React from 'react'

const KeylessCipherAlgo = () => {
    return (
        <div>
            <h3>Encryption:</h3>
            <ol>
                <li>In the rail fence cipher, the plain-text is written downwards and diagonally on successive rails of an imaginary fence.</li>
                
                <li>When we reach the bottom rail, we traverse upwards moving diagonally, after reaching the top rail, the direction is changed again. Thus the alphabets of the message are written in a zig-zag manner.
                </li>
                <li>After each alphabet has been written, the individual rows are combined to obtain the cipher-text.</li>
                <li>The resulting ciphertext is the encrypted message.</li>
            </ol>
            <br />
            <h3>Decryption:</h3>
            <ol>
                <li>Choose the same shift value (key) that was used for encryption.</li>
                <li>Hence, rail matrix can be constructed accordingly. Once we've got the matrix we can figure-out the spots where texts should be placed (using the same way of moving diagonally up and down alternatively ).
                </li>
                <li>Then, we fill the cipher-text row wise. After filling it, we traverse the matrix in zig-zag manner to obtain the original text.</li>
                <li>The resulting plaintext is the decrypted message.</li>
            </ol>
        </div>

    )
}

export default KeylessCipherAlgo